<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '140px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
          <el-form-item label="用户名" prop="userName">
          <el-input v-model="dataForm.userName" placeholder="用户名"></el-input>
      </el-form-item>
          <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="dataForm.realName" placeholder="真实姓名"></el-input>
      </el-form-item>
          <el-form-item label="登陆密码" prop="pwd">
          <el-input v-model="dataForm.pwd" placeholder="登陆密码"></el-input>
      </el-form-item>
          <el-form-item label="微信号" prop="webchatCode">
          <el-input v-model="dataForm.webchatCode" placeholder="微信号"></el-input>
      </el-form-item>
          <el-form-item label="微信昵称" prop="webchatName">
          <el-input v-model="dataForm.webchatName" placeholder="微信昵称"></el-input>
      </el-form-item>
          <el-form-item label="电子邮件" prop="email">
          <el-input v-model="dataForm.email" placeholder="电子邮件"></el-input>
      </el-form-item>
      <el-form-item label="会员等级" prop="vipLevelId">
          <!-- <el-input v-model="dataForm.vipLevelId" placeholder="1普通会员2黄金会员3铂金会员"></el-input> -->
          <el-select  v-model="dataForm.vipLevelId" filterable clearable  placeholder="请选择性别">
                  <el-option
                          v-for="item in vipLevels"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
      </el-form-item>
          <el-form-item label="会员名称" prop="vipLevelName">
          <el-input v-model="dataForm.vipLevelName" placeholder="会员名称"></el-input>
      </el-form-item>
        <el-form-item label="手机号码" prop="mobilePhone">
          <el-input v-model="dataForm.mobilePhone" placeholder="手机号码"></el-input>
      </el-form-item>
          <el-form-item label="证件ID" prop="cardId">
          <el-input v-model="dataForm.cardId" placeholder="证件ID"></el-input>
      </el-form-item>
          <el-form-item label="部门ID" prop="deptId">
          <el-input v-model="dataForm.deptId" placeholder="部门ID"></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
          <!-- <el-input v-model="dataForm.sex" placeholder="性别 1:男,0:女"></el-input> -->
          <el-select  v-model="dataForm.sex" filterable clearable  placeholder="请选择性别">
                  <el-option
                          v-for="item in sexList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <!-- <el-input v-model="dataForm.status" placeholder="状态 1:锁定，0:解锁"></el-input> -->
        <el-select  v-model="dataForm.status" filterable clearable  placeholder="请选择状态">
                  <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>

      </el-form-item>
      <el-form-item label="用户类型" prop="userType">
          <!-- <el-input v-model="dataForm.userType" placeholder="0:用户/1：经纪人/2:自然借款人/3:自然经纪人/4:线下借款人/5:合作机构经纪人"></el-input> -->
          <el-select  v-model="dataForm.userType" filterable clearable  placeholder="请选择">
                  <el-option
                          v-for="item in userTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
      </el-form-item>
      
      <el-form-item label="头像" prop="headStatus">
          <!-- <el-input v-model="dataForm.headStatus" placeholder="头像 0:默认,1:自定义"></el-input> -->
          <el-select  v-model="dataForm.headStatus" filterable clearable  placeholder="请选择">
                  <el-option
                          v-for="item in headStatusList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
      </el-form-item>
          <el-form-item label="头像URL" prop="headIco">
          <el-input v-model="dataForm.headIco" placeholder="头像URL"></el-input>
      </el-form-item>
       <el-form-item label="出生年月日" prop="birthday">
          <!-- <el-input v-model="dataForm.birthday" placeholder="出生年月日"></el-input> -->
          <el-date-picker
                  v-model="dataForm.birthday"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="学历" prop="education">
          <!-- <el-input v-model="dataForm.education" placeholder="学历"></el-input> -->
          <el-select  v-model="dataForm.education" filterable clearable  placeholder="请选择">
                  <el-option
                          v-for="item in educations"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="婚姻状况" prop="maritalStatus">
        
        <el-select  v-model="dataForm.maritalStatus" filterable clearable  placeholder="请选择">
                  <el-option
                          v-for="item in maritalStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
          <!-- <el-input v-model="dataForm.maritalStatus" placeholder="婚姻状况 0:未婚；1：已婚；2：离异；3：丧偶"></el-input> -->
      </el-form-item>
          <el-form-item label="户籍所在省" prop="province">
          <el-input v-model="dataForm.province" placeholder="户籍所在省"></el-input>
      </el-form-item>
          <el-form-item label="户籍所在市" prop="city">
          <el-input v-model="dataForm.city" placeholder="户籍所在市"></el-input>
      </el-form-item>
          <el-form-item label="地址" prop="address">
          <el-input v-model="dataForm.address" placeholder="地址"></el-input>
      </el-form-item>
  
      <el-form-item label="工作年限" prop="workExperience">
          <!-- <el-input v-model="dataForm.workExperience" placeholder="工作年限 1：0-3年；2：3-5年；3:5-8年；4:8年以上；"></el-input> -->
          <el-select  v-model="dataForm.workExperience" filterable clearable  placeholder="请选择">
                  <el-option
                          v-for="item in workExperience"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
      <el-form-item label="最后登录时间" prop="loginTime">
          
          <el-date-picker
                  v-model="dataForm.loginTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="密码修改时间" prop="pwdModifyTime">
          <el-date-picker
                  v-model="dataForm.pwdModifyTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="邀请人ID" prop="inviteUserId">
          <el-input v-model="dataForm.inviteUserId" placeholder="邀请人ID"></el-input>
      </el-form-item>
      <el-form-item label="认证状态" prop="isAuth">
          <!-- <el-input v-model="dataForm.isAuth" placeholder="状态 0:未认证 1:认证成功，2：认证失败"></el-input> -->
          <el-select  v-model="dataForm.isAuth" filterable clearable  placeholder="请选择">
                  <el-option
                          v-for="item in isAuth"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
      <el-form-item label="认证申请日期" prop="authApplyTime">
   
          <el-date-picker
                  v-model="dataForm.authApplyTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
      <el-form-item label="认证通过日期" prop="authTime">
       
          <el-date-picker
                  v-model="dataForm.authTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="微信唯一标识符" prop="openId">
          <el-input v-model="dataForm.openId" placeholder="微信唯一标识符"></el-input>
      </el-form-item> 
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      educations: [],
      userTypes: [],
      vipLevels: [],
      maritalStatus: [],
      isAuth: [],
      workExperience: [],
      headStatusList: [
          {
            value: 0,
            label:'默认'
          },
          {
            value: 1,
            label:'自定义'
          }
        ],
        headStatusList: [
          {
            value: 0,
            label:'默认'
          },
          {
            value: 1,
            label:'自定义'
          }
        ],
      sexList: [
          {
            value: 0,
            label:'女'
          },
          {
            value: 1,
            label:'男'
          }
        ],
        
        statusList:[
          {
            value: 0,
            label:'解锁'
          },
          {
            value: 1,
            label:'锁定'
          }
        ],
      dataForm: {
        id: '',
        userId: '',
        userName: '',
        realName: '',
        pwd: '',
        webchatCode: '',
        webchatName: '',
        email: '',
        vipLevelId: '',
        vipLevelName: '',
        mobilePhone: '',
        cardId: '',
        deptId: '',
        sex: '',
        status: '',
        userType: '',
        headStatus: '',
        headIco: '',
        birthday: '',
        education: '',
        maritalStatus: '',
        province: '',
        city: '',
        address: '',
        workExperience: '',
        loginTime: '',
        pwdModifyTime: '',
        inviteUserId: '',
        isAuth: '',
        authApplyTime: '',
        authTime: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: '',
        openId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        realName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        webchatCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        webchatName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        vipLevelId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        vipLevelName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobilePhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cardId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sex: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        userType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        headStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        headIco: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        education: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        maritalStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        province: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        workExperience: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        loginTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pwdModifyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        inviteUserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isAuth: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        authApplyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        authTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        openId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.geteducationOptions()
      this.getuserTypesOptions()
      this.getvipLevelOptions()
      this.getmaritalStatusOptions()
      this.getworkExperienceOptions()
      this.getisAuthOptions()
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
     //初始认证下拉框中的选项
     async getisAuthOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=isAuth`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.isAuth = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.isAuth.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
     //初始工作年限下拉框中的选项
     async getworkExperienceOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=workExperience`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.workExperience = [];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.workExperience.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
       //初始婚姻下拉框中的选项
       async getmaritalStatusOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=maritalStatus`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.maritalStatus=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.maritalStatus.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    
     //初始用户名称下拉框中的选项
     async getvipLevelOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=vipLevel`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.vipLevels=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.vipLevels.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    //初始用户名称下拉框中的选项
    async getuserTypesOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=userType`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.userTypes=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.userTypes.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
      //初始学历名称下拉框中的选项
      async geteducationOptions() {
           this.$http.get(`/sys/dict/data/list?dataType=education`).then(({ data: res }) => {
              if (res.code !== 0) {
                  return this.$message.error(res.msg)
              }
              this.educations=[];
              if (res.data!=null){
                  res.data.forEach(element => {
                      this.educations.push({label:element.dictLabel,value:element.dictValue})
                  })
              }
          }).catch(() => {})
      },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/sluser/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/sluser/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
